import { render, staticRenderFns } from "./OtherLibraries.vue?vue&type=template&id=60e8be90&scoped=true"
import script from "./OtherLibraries.vue?vue&type=script&lang=js"
export * from "./OtherLibraries.vue?vue&type=script&lang=js"
import style0 from "./OtherLibraries.vue?vue&type=style&index=0&id=60e8be90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e8be90",
  null
  
)

export default component.exports